<template>
  <div class="StoreEdit" v-title data-title="水产圈子门店明细">
    <div>
      <div :class="`row pt7 pl7 pr7 ${field.block ? 'vertical justify-content-center' : 'align-items-center'}`" v-for="field in fields" :key="field.dataIndex">
        <div :class="`${field.block ? '' : 'col-6'}`">
          <span v-if="field.required" class="fc-danger">*</span>{{ field.title }}：
        </div>
        <div :class="`flex-1`">
          <template v-if="field.type === 'upload'">
            <van-uploader
              :id="field.dataIndex"
              class="col pt5"
              width="100%"
              height="110"
              v-model="detailInfo[field.dataIndex]"
              multiple
              :max-count="field.maxCount"
              :after-read="afterRead"
              :preview-full-image="true"
              image-fit="cover"
              @delete="deleteImage"
            />
          </template>
          <template v-else-if="field.type === 'text'">
            <div>
              {{ detailInfo[field.dataIndex] || '-'}}
            </div>
          </template>
          <template v-else-if="field.type === 'link'">
            <a :href="detailInfo[field.dataIndex]" target="_blank">
              {{ detailInfo[field.dataIndex] || '-'}}
            </a>
          </template>
          <template v-else-if="field.type === 'select'">
            <select class="w100p" v-model="detailInfo[field.dataIndex]" @change="changeSelect(field)" :placeholder="`请选择${field.title||''}`">
              <option value="">请选择{{ field.title || '' }}</option>
              <option v-for="ps in options[field.dataIndex]||[]" :value ="ps.code" :key="ps.code">
                {{ps.name}}
              </option>
            </select>
          </template>
          <template v-else-if="field.type === 'textarea'">
            <textarea v-model="detailInfo[field.dataIndex]" class="w100p" :placeholder="`请输入${field.title||''}`"></textarea>
          </template>
          <template v-else>
            <input v-model="detailInfo[field.dataIndex]" class="w100p" :placeholder="`请输入${field.title||''}`"/>
          </template>
        </div>
      </div>
      <div class="padding7">
        <van-button class="w100p mt7" @click="save" type="info" :loading="loading">保存</van-button>
        <!-- <van-button class="w100p mt7" @click="approve" type="primary" :loading="loading">通过</van-button>
        <van-button class="w100p mt7" @click="reject" type="danger" :loading="loading">不通过</van-button> -->
        <van-button class="w100p mt7" @click="back" plain type="info">返回</van-button>
      </div>
    </div>

    <van-dialog v-model="rejectReasonShow" title="不通过原因" @confirm="rejectStatus">
      <div class="padding7">
        <input v-model="rejectReason" class="w100p" placeholder="请输入不通过原因"/>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  sendRequest, getStoreDetail, uploadFile, upload, storeApprove, storeReject, storeEdit, getregion,
} from '@/network/NetworkAccessor';
import config from '@/config';

const areaFields = ['provinceCode', 'cityCode', 'areaCode', 'townCode'];

export default Vue.extend({
  name: 'StoreEdit',
  components: {},
  data() {
    return {
      fileDomain: config.FILE_DOMAIN,
      loading: false,
      detailInfo: {},
      rejectReason: '',
      rejectReasonShow: false,
      fields: [
        {
          dataIndex: 'storeName',
          title: '门店名称',
          required: true,
        },
        {
          dataIndex: 'nickname',
          title: '昵称',
          type: 'text',
        },
        {
          dataIndex: 'storePhone',
          title: '门店手机号',
          required: true,
        },
        {
          dataIndex: 'openingHours',
          title: '营业时间',
        },
        {
          dataIndex: 'provinceCode',
          title: '省',
          type: 'select',
          required: true,
        },
        {
          dataIndex: 'cityCode',
          title: '市',
          type: 'select',
        },
        {
          dataIndex: 'areaCode',
          title: '区',
          type: 'select',
        },
        {
          dataIndex: 'townCode',
          title: '乡镇',
          type: 'select',
        },
        {
          dataIndex: 'address',
          title: '详细地址',
          required: true,
        },
        {
          dataIndex: 'latitudeLongitude',
          title: '门店定位（经纬度）',
          placeholder: '请输入门店经纬度，格式：维度,经度',
        },
        {
          dataIndex: 'toolLink',
          title: '获取经纬度工具地址',
          type: 'link',
        },
        {
          dataIndex: 'streetNumber',
          title: '门店市场编号',
        },
        {
          dataIndex: 'introduction',
          title: '简介',
          type: 'textarea',
        },
        {
          dataIndex: 'payStatusName',
          title: '支付状态',
          type: 'text',
        },
        {
          dataIndex: 'payTime',
          title: '支付时间',
          type: 'text',
        },
        {
          dataIndex: 'statusName',
          title: '审核状态',
          type: 'text',
        },
        {
          dataIndex: 'rejectReason',
          title: '原因',
          type: 'text',
        },
        {
          dataIndex: 'rangeTime',
          title: '有效期',
          type: 'text',
        },
        {
          dataIndex: 'createTime',
          title: '提交审核时间',
          type: 'text',
        },
        {
          dataIndex: 'facade',
          title: '门店门头照片(1张)',
          type: 'upload',
          block: true,
          maxCount: 1,
          required: true,
        },
        {
          dataIndex: 'place',
          title: '门店经营照片(3张)',
          type: 'upload',
          block: true,
          maxCount: 3,
        },
        {
          dataIndex: 'license',
          title: '营业执照、租赁合同(2张)',
          type: 'upload',
          block: true,
          maxCount: 2,
        },
      ],
      editItem: {},
      options: {

      },
    };
  },
  props: {
    storeId: {
      type: String,
      default: null,
    },
  },
  methods: {
    init() {
      const obj = {};
      this.fields.forEach((item) => {
        if (item.type === 'upload') {
          obj[item.dataIndex] = [];
        } else {
          obj[item.dataIndex] = '';
        }
      });
      this.detailInfo = obj;
    },
    changeSelect(field) {
      if (!field) {
        return;
      }
      const type = field.dataIndex;
      const index = areaFields.findIndex(val => val === type);
      // 省市区选择
      if (index > -1) {
        const pcode = this.detailInfo[type];
        const optionsKey = areaFields[index + 1] || '';
        areaFields.forEach((val, valIndex) => {
          if (valIndex > index) {
            this.$set(this.detailInfo, val, '');
            this.$set(this.options, val, []);
          }
        });
        if (optionsKey) {
          this.getRegion(optionsKey, pcode);
        }
      }
    },
    getRegion(optionsKey = areaFields[0], pcode) {
      sendRequest(getregion, { pcode }).then((res = []) => {
        const options = res || [];
        this.$set(this.options, optionsKey, options);
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message,
        });
      });
    },
    validValues() {
      const list = this.fields.filter((field) => {
        console.log(field.title, field, this.detailInfo[field.dataIndex]);
        return field.required && (!this.detailInfo[field.dataIndex] || !this.detailInfo[field.dataIndex].length);
      });
      if (list.length) {
        this.$dialog.alert({
          message: `请补充${list.map(item => item.title).join('、')}`,
        });
      }
      return !list.length;
    },
    approve(params = {}) {
      if (!this.validValues()) {
        return;
      }
      this.editItem = { ...this.detailInfo };
      this.$dialog.confirm({
        title: '确定',
        message: '确定审核通过吗？',
      }).then(() => {
        sendRequest(storeApprove, {
          id: this.editItem.id,
        }).then((res) => {
          this.getStoreDetail();
          this.$dialog.alert({
            message: '操作成功',
          });
        }).catch((e) => {
          console.log(e);
          this.$dialog.alert({
            message: `${e.message}`,
          });
        }).then(() => {
          this.$nextTick(() => {
            this.loading = false;
          });
        });
      });
    },
    reject(item = {}) {
      if (!this.validValues()) {
        return;
      }
      this.rejectReason = '';
      this.editItem = {};
      this.$dialog.confirm({
        title: '确定',
        message: '确定不通过吗？',
      }).then(() => {
        this.rejectReasonShow = true;
        this.editItem = { ...this.detailInfo };
      });
    },
    rejectStatus() {
      if (!this.rejectReason) {
        this.$dialog.alert({
          message: '请输入拒绝原因',
        });
        return;
      }
      sendRequest(storeReject, {
        id: this.editItem.id,
        rejectReason: this.rejectReason,
      }).then((res) => {
        this.getStoreDetail();
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((e) => {
        console.log(e);
        this.$dialog.alert({
          message: `${e.message}`,
        });
      }).then(() => {
        this.$nextTick(() => {
          this.loading = false;
        });
      });
    },
    deleteImage(e) {
      console.log('deleteImage ', e);
    },
    afterRead(file) {
      // console.log('afterRead ', file);
      this.uploadSource(file);
    },
    uploadSource(file) {
      this.uploadLoading = true;
      const params = new FormData();
      params.append('file', file.file);
      upload(uploadFile, params).then((url = '') => {
        // console.log('upload ', url);
        this.$set(file, 'url', this.fileDomain + url);
      }).catch((e) => {
        this.$dialog.alert({
          message: e.message,
        });
      }).then(() => {
        this.uploadLoading = false;
      });
    },
    getStoreDetail() {
      sendRequest({
        ...getStoreDetail,
        url: `${getStoreDetail.url}/${this.storeId}`,
      }, {}).then((res = {}) => {
        const detailInfo = {};
        this.fields.filter(field => field.type === 'upload').forEach((field) => {
          if (res[field.dataIndex]) {
            detailInfo[field.dataIndex] = res[field.dataIndex].split(',').map(url => ({
              url: this.fileDomain + url,
            }));
          }
        });
        this.detailInfo = {
          ...this.detailInfo,
          ...res,
          ...detailInfo,
          rangeTime: (res.approveTime && res.expirationTime) ? `${res.approveTime} ~ ${res.expirationTime}` : '',
          latitudeLongitude: res.latitude && res.longitude ? `${res.latitude},${res.longitude}` : '',
          toolLink: 'https://lbs.qq.com/getPoint/',
        };
        areaFields.forEach((val, valindex) => {
          if (valindex === 0 || this.detailInfo[areaFields[valindex - 1]]) {
            this.getRegion(val, this.detailInfo[areaFields[valindex - 1]]);
          }
        });
      }).catch((error) => {
        console.error(error);
        this.$dialog.alert({
          message: error.message,
        });
      });
    },
    save() {
      if (!this.validValues()) {
        return;
      }
      const detailInfo = {};
      this.fields.filter(field => field.type === 'upload').forEach((field) => {
        detailInfo[field.dataIndex] = this.detailInfo[field.dataIndex].map(file => file.url.replace(this.fileDomain, '')).join(',');
      });
      const { latitudeLongitude = '' } = this.detailInfo;
      const [latitude = '', longitude = ''] = latitudeLongitude.replace('，', ',').split(',');
      sendRequest(storeEdit, {
        ...this.detailInfo,
        ...detailInfo,
        longitude,
        latitude,
      }).then((res = {}) => {
        this.$dialog.alert({
          message: '操作成功',
        });
      }).catch((error) => {
        console.error(error);
        this.$dialog.alert({
          message: error.message,
        });
      });
    },
    back() {
      // this.$router.back();
      this.$router.push('/store/apply/list');
    },
  },
  created() {
    this.init();
    this.getStoreDetail();
  },
});
</script>
<style scoped>
  .StoreEdit {
    min-height: 100vh;
    background-color: #ffffff;
    font-size: 14px;
    text-align: left;
  }
</style>
